import BaseInputComponent from "basecomponents/BaseInputComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { InputField, TextArea, CheckField } from "../components/form";
import { SmallSpinner } from "../components/loaders";

import {
  removeNullProperties,
  joinObjects,
  objectIsEmpty,
} from "../utils/jsonUtils";
import { hideModal } from "../utils/domUtils";

// Actions
import {
  setClientEditFromFunction,
  editClient,
} from "../actions/clientActions";

class AdminEditClientModal extends BaseInputComponent {
  modal_id = "modal_edit_client";

  state = {
    id: null,
    user: "",
    email: "",
    name: "",
    phone: "",
    code: "",
    address: "",
    password: "",
    is_active: false,
    is_verified: false,
    //
    information_setted: false,
    prevent_set_state: false,
    errors: {},
  };

  static getDerivedStateFromProps(nextProps, currentState) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }

    if (
      !objectIsEmpty(nextProps.client.item) &&
      !currentState.information_setted &&
      !currentState.prevent_set_state
    ) {
      newState = joinObjects(newState, nextProps.client.item);
      newState["information_setted"] = true;
    }

    if (!newState.changed) return null;

    return removeNullProperties(newState);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.client.loadingOperation;
  }

  clearForm = () => {
    this.setState(
      {
        id: null,
        user: "",
        email: "",
        name: "",
        phone: "",
        code: "",
        address: "",
        password: "",
        is_active: false,
        is_verified: false,
        //
        information_setted: false,
        prevent_set_state: true,
        errors: {},
      },
      () => {
        this.setState({ prevent_set_state: false });
      }
    );
  };

  onCancelClick = () => {
    // @ts-ignore
    this.props.setClientEditFromFunction(null);
    this.clearForm();
    hideModal(this.modal_id);
  };

  onAcceptClick = () => {
    const {
      id,
      user,
      email,
      name,
      phone,
      code,
      address,
      password,
      is_active,
      is_verified,
    } = this.state;
    // @ts-ignore
    const id_user = this.props.client.item.id_user;
    // @ts-ignore
    this.props.editClient(
      id_user,
      {
        id,
        user,
        email,
        name,
        phone,
        code,
        address,
        password,
        is_active,
        is_verified,
      },
      (success) => {
        if (!success) return;

        this.clearForm();
        this.onCancelClick();
      }
    );
  };

  getForm = () => {
    const {
      user,
      email,
      name,
      phone,
      code,
      address,
      password,
      is_active,
      is_verified,
      errors,
    } = this.state;
    const loading = this.isLoading();
    return (
      <>
        <div className="grid-2-col">
          <InputField
            id="edit_client_name"
            value={name}
            name="name"
            label="Nombre"
            error={errors}
            onChange={this.onChangeTextInput}
            disabled={loading}
          />
          <InputField
            id="edit_client_code"
            name="code"
            value={code}
            label="Codigo de cliente"
            error={errors}
            onChange={this.onChangeTextInput}
            disabled={loading}
          />
        </div>

        <div className="grid-2-col">
          <InputField
            id="edit_client_phone"
            name="phone"
            value={phone}
            label="Telefono"
            error={errors}
            onChange={this.onChangeTextInput}
            disabled={loading}
          />
          <InputField
            id="edit_client_email"
            name="email"
            value={email}
            label="Correo"
            error={errors}
            type="email"
            onChange={this.onChangeTextInput}
            disabled={loading}
          />
        </div>

        <div className="grid-2-col">
          <InputField
            id="edit_client_user"
            name="user"
            value={user}
            label="Nombre de usuario"
            placeholder="Opcional"
            error={errors}
            onChange={this.onChangeTextInput}
            disabled={loading}
          />
          <InputField
            id="edit_client_password"
            name="password"
            value={password}
            label="Clave"
            placeholder="Sin cambios"
            error={errors}
            onChange={this.onChangeTextInput}
            type="password"
            disabled={loading}
          />
        </div>

        <TextArea
          id="edit_client_address"
          name="address"
          value={address}
          label="Direcci&oacute;n de envio (opcional)"
          error={errors}
          onChange={this.onChangeTextInput}
          disabled={loading}
        />

        <div className="grid-2-col form-row">
          <CheckField
            id="edit_client_is_active"
            name="is_active"
            label="Activo"
            checked={is_active}
            onChange={this.onChangeCheckField}
            error={errors}
            disabled={loading}
          />

          <CheckField
            id="edit_client_is_verified"
            name="is_verified"
            label="Verificado"
            checked={is_verified}
            onChange={this.onChangeCheckField}
            error={errors}
            disabled={loading}
          />
        </div>

        {loading && <SmallSpinner center={true} />}
      </>
    );
  };

  render() {
    return (
      <div
        className="modal fade"
        id={this.modal_id}
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Editar cliente</h5>
            </div>
            <div className="modal-body">{this.getForm()}</div>
            <div className="modal-footer">
              <div className="flex-2-separated">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.onCancelClick}
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.onAcceptClick}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
AdminEditClientModal.propTypes = {
  client: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setClientEditFromFunction: PropTypes.func.isRequired,
  editClient: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  client: state.client,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  editClient,
  setClientEditFromFunction,
})(AdminEditClientModal);
